import { useEffect, useState } from "react";
import api from "@/lib/api";
import Layout, { PageHeader } from "@/components/Layout";
import { Scroll } from "@phosphor-icons/react";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)); }, []);

  return (
    <Layout>
      <PageHeader title="Audit Logs" subtitle="Immutable record of every action in your tenant" />
      <div className="p-8">
        <div className="bg-white border border-stone-200 rounded-2xl shadow-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider text-stone-500 border-b border-stone-200">
                <th className="px-6 py-3 font-semibold">Time</th>
                <th className="px-6 py-3 font-semibold">Actor</th>
                <th className="px-6 py-3 font-semibold">Action</th>
                <th className="px-6 py-3 font-semibold">Entity</th>
                <th className="px-6 py-3 font-semibold">Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-stone-100 hover:bg-stone-50 transition-colors duration-200">
                  <td className="px-6 py-3 text-xs text-stone-500 font-mono">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="px-6 py-3 text-xs">{l.actor_email}</td>
                  <td className="px-6 py-3"><span className="px-2 py-0.5 bg-stone-100 rounded-xl text-xs font-medium">{l.action}</span></td>
                  <td className="px-6 py-3 text-xs text-stone-600">{l.entity_type}</td>
                  <td className="px-6 py-3 text-xs text-stone-400 font-mono">{JSON.stringify(l.details)}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan={5} className="px-6 py-16 text-center text-stone-400"><Scroll size={32} className="mx-auto mb-3 text-stone-300" />No audit events yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
